import React from 'react'
import { Provider } from 'react-redux';
import store from './stores/store';
import TestList  from './pages/newRun/testList';
import CreateTest  from './pages/newRun/createTest';
import {IntlProvider} from "react-intl";
// Note: 'oakRun' alias is resolved based on build type in craco.config.js
import Results from 'oakRun';
import { aqtStore } from 'Components/State/Store';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import AppWrapper from './app';

const App = () => {
  return (
    <Results
        jwtToken={aqtStore.getState().session.idToken.jwtToken}
        environment={aqtStore.getState().environment}
      />
  )
}

export default App;
